/**
 * Dispatch Deck color tokens — the single source of truth (epic #835).
 *
 * Consumed by BOTH `tailwind.config.ts` (to generate utilities) and
 * `test/design-tokens-contrast.test.ts` (to enforce the WCAG contract).
 * Change a value here and the contrast test — not a reviewer's eyeball —
 * decides whether it ships.
 *
 * `DECK_COLORS` is the complete palette — the legacy Material-3 bridge
 * (`BRIDGE_COLORS`) was removed in the epic #835 consolidation once the
 * last page migrated.
 */
export const DECK_COLORS = {
  // Surfaces (warm graphite ramp, brown undertone)
  canvas: '#131110',
  card: '#1B1917',
  raised: '#242220',
  active: '#2D2A27',
  well: '#0F0E0C',
  // Hairlines
  line: '#332E29',
  'line-soft': '#262320',
  'line-strong': '#4A443D',
  // Text (paper ramp; `paper-low` is the smallest functional tier;
  // `paper-faint` is disabled/placeholder ONLY)
  paper: '#EDE6DC',
  'paper-mid': '#A89E92',
  'paper-low': '#8D8375',
  'paper-faint': '#6E665C',
  // Signal orange (family-linked to landing-web's Claude orange)
  signal: '#E08D5D',
  'signal-bright': '#EBA173',
  'signal-deep': '#C4693C',
  'signal-ink': '#2B1A10',
  'signal-dim': '#2B1D12',
  // Board lamps
  ok: '#86BB8E',
  'ok-dim': '#2A3A2C',
  'ok-line': '#334735',
  warn: '#E3B34C',
  'warn-dim': '#3D3319',
  'warn-line': '#55441F',
  bad: '#E26D5A',
  'bad-dim': '#422019',
  'bad-line': '#5A2C22',
  'bad-bright': '#FFC9BE',
} as const;



export type DeckColorName = keyof typeof DECK_COLORS;
